import React, { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import { Spinner } from "react-bootstrap";

const GraficoOrdiniOggi = () => {
  const [dataGrafico, setDataGrafico] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const ordini = data?.ORDINI_OGGI?.flat() || [];

        // Contiamo quanti sono OF4G e quanti Altri
        const contaOF4G = ordini.filter(
          (item) => item.tipo_doc === "OF4G",
        ).length;
        const contaAltri = ordini.length - contaOF4G;

        setDataGrafico([
          { name: "Ordini Urgenti", value: contaOF4G, color: "#b81f25" }, // Rosso
          { name: "Altri Ordini", value: contaAltri, color: "#444444" }, // Grigio scuro
        ]);

        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch grafico:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div
      className="bg-white widget-client2 ombra tb"
      style={{
        borderRadius: "10px",
        border: "1px solid #c2c2c2",
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="mt-2 text-center">
        <span className="text-title">TIPO ORDINI</span>
      </div>

      <div style={{ flexGrow: 1, width: "100%", height: "300px" }}>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <Spinner animation="border" variant="danger" />
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={dataGrafico}
                cx="50%"
                cy="50%"
                innerRadius={60} // Effetto ciambella
                outerRadius={80}
                paddingAngle={5}
                dataKey="value"
                stroke="none"
              >
                {dataGrafico.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  backgroundColor: "#222",
                  border: "1px solid #444",
                  color: "#fff",
                }}
                itemStyle={{ color: "#fff" }}
              />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        )}
      </div>

      {!loading && (
        <div className="text-center mt-2">
          <small className="text-secondary">
            Totale ordini oggi: {dataGrafico[0].value + dataGrafico[1].value}
          </small>
        </div>
      )}
    </div>
  );
};

export default GraficoOrdiniOggi;
